import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import Table from "../../../../../../Components/Table";
import { IEquipeVendasPorUsuario } from "../../../../../../Interfaces/Vendas/EquipeVendas/EquipeVendasInterfaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import { UsuarioInterface } from "../../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";

interface IDesvincularEquipeUsuarioProps {
    USER: UsuarioInterface;

    lstEquipeVendasVinculadas: IEquipeVendasPorUsuario[] | undefined;
    lstEquipeVendasVinculadasLoading: boolean;

    DesvincularEquipeVendasUsuario: (requestBody: number[]) => Promise<any>;
    DesvincularEquipeVendasUsuarioLoading: boolean;

    lstSelecionadosNaoVinculados: IEquipeVendasPorUsuario[];
    setLstSelecionadosNaoVinculados: Dispatch<
        SetStateAction<IEquipeVendasPorUsuario[]>
    >;

    ListarEquipeVendasDesvinculadosPorUsuario: (
        ...args: any[]
    ) => Promise<IEquipeVendasPorUsuario[] | undefined>;
    ListarEquipeVendasVinculadosPorUsuario: (
        ...args: any[]
    ) => Promise<IEquipeVendasPorUsuario[] | undefined>;
}

export default function DesvincularEquipeUsuario(
    props: IDesvincularEquipeUsuarioProps
) {
    console.log(props.lstSelecionadosNaoVinculados);

    const columns: Array<ColumnDescription<IEquipeVendasPorUsuario>> = [
        { dataField: "DS_EQUIPE_VENDAS", text: "Equipes Vinculadas" },
        {
            dataField: "action",
            text: "",
            formatter: (cell, row) => (
                <button
                    className="btn btn-outline-danger"
                    onClick={() => {
                        props
                            .DesvincularEquipeVendasUsuario([
                                row.ID_EQUIPE_VENDAS_USUARIO ?? 0,
                            ])
                            .then(() => {
                                props.ListarEquipeVendasDesvinculadosPorUsuario();
                                props.ListarEquipeVendasVinculadosPorUsuario();
                                props.setLstSelecionadosNaoVinculados([]);
                            });
                    }}
                >
                    <FontAwesomeIcon icon={faArrowDown} size="sm" /> Desvincular
                </button>
            ),
        },
    ];

    const selectRowProp: SelectRowProps<IEquipeVendasPorUsuario> = {
        mode: "checkbox",
        clickToSelect: true,
        onSelect: (row, isSelect) => {
            if (isSelect) {
                props.setLstSelecionadosNaoVinculados((prev) => [...prev, row]);
            } else {
                props.setLstSelecionadosNaoVinculados((prev) =>
                    prev.filter(
                        (item) => item.ID_EQUIPE_VENDAS !== row.ID_EQUIPE_VENDAS
                    )
                );
            }
        },
        onSelectAll: (isSelect, rows) => {
            if (isSelect) {
                props.setLstSelecionadosNaoVinculados(rows);
            } else {
                props.setLstSelecionadosNaoVinculados([]);
            }
        },
    };

    return (
        <OrSpinner
            loading={props.lstEquipeVendasVinculadasLoading}
            spinner="capys"
        >
            <Table
                data={props.lstEquipeVendasVinculadas || []}
                columns={columns}
                keyField="ID_EQUIPE_VENDAS"
                selectRow={selectRowProp}
                noDataIndication={
                    <div className="text-center text-muted">
                        Nenhuma Equipe Vinculada
                    </div>
                }
                loading={props.lstEquipeVendasVinculadasLoading}
                wrapperClasses="wrapperTable mw-100 x-scroll"
                classes="tableClasses"
                bordered={false}
                center
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
            />
            <div className="d-flex col-12 justify-content-center mb-3">
                <button
                    className="btn btn-outline-danger"
                    onClick={() => {
                        if (props.lstSelecionadosNaoVinculados.length > 0) {
                            props
                                .DesvincularEquipeVendasUsuario(
                                    props.lstSelecionadosNaoVinculados.map(
                                        (lst) =>
                                            lst.ID_EQUIPE_VENDAS_USUARIO ?? 0
                                    )
                                )
                                .then(() => {
                                    props.ListarEquipeVendasDesvinculadosPorUsuario();
                                    props.ListarEquipeVendasVinculadosPorUsuario();
                                    props.setLstSelecionadosNaoVinculados([]);
                                });
                        }
                    }}
                    disabled={props.lstSelecionadosNaoVinculados.length === 0}
                >
                    <FontAwesomeIcon icon={faArrowDown} size="sm" /> Desvincular
                    Selecionados
                </button>
            </div>
        </OrSpinner>
    );
}
